import type { Track } from '~/api/types'
import { coverArtUrlFor } from '~/lib/cover-art'
import type { QueueItem } from './types'

export function updateMediaSession(track: QueueItem): void {
  if (!('mediaSession' in navigator)) return
  const art = coverArtUrlFor({ type: 'tracks', id: track.id, coverArt: track.coverArt })
  navigator.mediaSession.metadata = new MediaMetadata({
    title: track.title,
    artist: track.artist,
    album: track.album,
    artwork: art ? [{ src: art, sizes: '300x300' }] : [],
  })
}

export function queueItemUid(): string {
  return crypto.randomUUID()
}

export function trackToQueueItem(track: Track): QueueItem {
  return {
    uid: queueItemUid(),
    id: track.id,
    title: track.title,
    artist: track.artist,
    artistId: track.artistId,
    album: track.album,
    albumId: track.albumId,
    duration: track.duration,
    coverArt: track.coverArt,
    replayGain: track.replayGain ?? null,
    tempo: track.tempo ?? null,
    keyName: track.keyName ?? null,
    energy: track.energy ?? null,
    mood: track.mood ?? null,
  }
}
